import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Router,
  NavigationStart,
} from '@angular/router';
import { filter, finalize, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderSpinnerService } from './loader-spinner.service';
import { LoaderSpinnerTypes } from '../models/loader-types.model';
import { loaderSpinnerContext } from '@carm/shared/constants/const-carm';

@Injectable()
export class LoaderSpinnerInterceptor implements HttpInterceptor {
  SPINNER_HIDE_TIMEOUT = environment.httpConfig.getTimeout; // hide spinner if request take over 45 seconds.

  private runningWrapperRequests: HttpRequest<any>[] = [];
  private runningFullPageRequests: HttpRequest<any>[] = [];

  constructor(
    public loaderSpinnerService: LoaderSpinnerService,
    private router: Router,
  ) {
    router.events // if navigating, reset spinner
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe(() => {
        this.runningWrapperRequests = [];
        this.runningFullPageRequests = [];
      });
  }

  /**
   * Intercepts http customer header interceptor - added custom headers to each http request
   * @param request http request
   * @param next http handle
   * @returns intercept
   */

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    const currentRoute = this.router.url;
    if (!currentRoute?.endsWith('dashboard') && !request.url.includes('/deployment/time')) {

      switch(request.context.get(loaderSpinnerContext)){
        case LoaderSpinnerTypes.None:
          break;
        case LoaderSpinnerTypes.AgGrid:
          this.runningWrapperRequests.push(request);
          break;
        default:
          this.runningFullPageRequests.push(request);
          break;
      }

      this.loaderSpinnerService.displaySpinner = this.runningFullPageRequests.length > 0;
      this.loaderSpinnerService.displayWrappedSpinner = this.runningWrapperRequests.length > 0;

    } else {
      this.loaderSpinnerService.displaySpinner = false;
      this.loaderSpinnerService.displayWrappedSpinner = false;
    }

    return next.handle(request).pipe(
     // debounceTime(this.SPINNER_HIDE_TIMEOUT * 2), // in case server doesn't respond (shutdown?)
      timeout(this.SPINNER_HIDE_TIMEOUT),
      finalize<HttpResponse<any>>(() => {
        const requestFullPageIndex = this.runningFullPageRequests.findIndex(r => r === request);
        const requestWrapperIndex = this.runningWrapperRequests.findIndex(r => r === request);

        if (requestFullPageIndex >= 0) {
          this.runningFullPageRequests.splice(requestFullPageIndex, 1);
        }

        if (requestWrapperIndex >= 0) {
          this.runningWrapperRequests.splice(requestWrapperIndex, 1);
        }

        this.loaderSpinnerService.displaySpinner = this.runningFullPageRequests.length > 0;
        this.loaderSpinnerService.displayWrappedSpinner = this.runningWrapperRequests.length > 0;
      }),
    );
  }
}
